import { createReducer, on } from '@ngrx/store';
import { CommunicationAnalyticsActions } from './communication-analytics.actions';
import { CommunicationAnalyticsState, initialCommunicationAnalyticsState } from './models/communication-analytics-state.models';

export const communicationAnalyticsReducer = createReducer(
  initialCommunicationAnalyticsState,

  on(CommunicationAnalyticsActions.loadOverview, (state): CommunicationAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CommunicationAnalyticsActions.loadOverviewSuccess, (state, { overview }): CommunicationAnalyticsState => ({
    ...state,
    overview,
    loading: false,
    error: null
  })),
  on(CommunicationAnalyticsActions.loadOverviewFailure, (state, { error }): CommunicationAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(CommunicationAnalyticsActions.loadTrend, (state): CommunicationAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CommunicationAnalyticsActions.loadTrendSuccess, (state, { trend }): CommunicationAnalyticsState => ({
    ...state,
    trend,
    loading: false,
    error: null
  })),
  on(CommunicationAnalyticsActions.loadTrendFailure, (state, { error }): CommunicationAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(CommunicationAnalyticsActions.loadTimePattern, (state): CommunicationAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CommunicationAnalyticsActions.loadTimePatternSuccess, (state, { timePattern }): CommunicationAnalyticsState => ({
    ...state,
    timePattern,
    loading: false,
    error: null
  })),
  on(CommunicationAnalyticsActions.loadTimePatternFailure, (state, { error }): CommunicationAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(CommunicationAnalyticsActions.clearCommunicationAnalyticsState, (): CommunicationAnalyticsState => ({
    ...initialCommunicationAnalyticsState
  }))
);
